<template>
    <div>
      <!-- Drawer抽屉 -->
      <el-dialog  :close-on-click-modal="false"  :visible.sync="visible" width="40%" >
        <div :style="{maxHeight: maxHeight}" class="drawer-content">
          <Form ref="form" :model="form" :rules="formValidate"  label-position="top">
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="公司名称" prop="compName" >
                  <Input v-model="form.compName" readonly/>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="用户名" prop="userName" >
                  <Input v-model="form.userName" placeholder="请输入登录账号" clearable/>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="密码" prop="passWord" >
                  <Input v-model="form.passWord" type="password" placeholder="请输入初始密码"  clearable/>
                </FormItem>
              </Col>
            </Row>
       
          </Form>
        </div>
        <div class="drawer-footer br" style="text-align:right" slot="footer" v-show="type!='0'">
          <el-button  type="primary" :loading="submitLoading" @click="submit">提交</el-button>
          <el-button @click="visible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  // 根据你的实际请求api.js位置路径修改
  import { addCompanyUser } from "@/api/index";
  export default {
    name: "addEdit",
    components: {
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object
      },
      type: {
        type: String,
        default: "0"
      }
    },
    data() {
      return {
        visible: this.value,
        title: "",
        submitLoading: false,
        maxHeight: 510,
        form: { // 添加或编辑表单对象初始化数据
          compName: "",
        },
        // 表单验证规则
        formValidate: {
        compName: [{ type: "string", required: true, message: "请输入", trigger: "blur" }],
        userName: [{ type: "string", required: true, message: "请输入", trigger: "blur" }],
        passWord: [{ type: "string", required: true, message: "请输入", trigger: "blur" }],
      }
      };
    },
    methods: {
      init() {
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.type == "1") {
              // 编辑
              this.submitLoading = true;
              addCompanyUser(this.form).then(res => {
                this.submitLoading = false;
                if (res.success) {
                  this.$Message.success("操作成功");
                  this.$emit("on-submit", true);
                  this.visible = false;
                }
              });
            } else {
              // // 添加
              // this.submitLoading = true;
              // addCompanyUser(this.form).then(res => {
              //   this.submitLoading = false;
              //   if (res.success) {
              //     this.$Message.success("操作成功");
              //     this.$emit("on-submit", true);
              //     this.visible = false;
              //   }
              // });
            }
          }
        });
      },
      setCurrentValue(value) {
        if (value === this.visible) {
          return;
        }
        if (this.type == "1") {
          this.title = "编辑";
          this.maxHeight =
            Number(document.documentElement.clientHeight - 121) + "px";
        } else if (this.type == "2") {
          this.title = "添加";
          this.maxHeight =
            Number(document.documentElement.clientHeight - 121) + "px";
        } else {
          this.title = "详细信息";
          this.maxHeight = "100%";
        }
        // 清空数据
        //this.$refs.form.resetFields();
        if (this.type == "0" || this.type == "1") {
          // 回显数据处理
          this.form = {
            compName: "",
          }
          this.form.compId = this.data.id;
          this.form.compName = this.data.compName;
        } else {
          // 添加
          delete this.form.id;
        }
        this.visible = value;
      }
    },
    watch: {
      value(val) {
        this.setCurrentValue(val);
      },
      visible(value) {
        this.$emit("input", value);
      }
    },
    mounted() {
      this.init();
    }
  };
  </script>
  
  <style lang="less">
  @import "@/styles/drawer-common.less";
  </style>